import { captureError } from './sentry';

/**
 * Logger central do Dream4 Webapp.
 *
 * Substitui console.log direto por um ponto único que:
 *   - Em DEV (NODE_ENV !== 'production') imprime tudo no console.
 *   - Em PROD silencia debug/info, mantém warn/error.
 *   - logger.error envia automaticamente para o Sentry (TD-008 Onda 1).
 *     Quando SENTRY_DSN não está configurada, vira no-op silencioso.
 *
 * Convenção de uso:
 *   logger.debug(...)  — diagnóstico verboso (some em prod).
 *   logger.info(...)   — eventos esperados (some em prod).
 *   logger.warn(...)   — atenção; aparece em qualquer ambiente.
 *   logger.error(...)  — falha real; aparece em qualquer ambiente e
 *                        vai para Sentry sem rewrite de call sites.
 *
 * Origem: TD-013 (logger central) + TD-008 (Sentry plug-in no error).
 */

const isProduction = process.env.NODE_ENV === "production";

/**
 * Extrai um Error nativo do array de args para mandar pro Sentry com
 * stack trace. Estratégia:
 *   - se algum arg já é Error → usa ele
 *   - senão constrói Error a partir do primeiro arg (stringificado)
 *   - args restantes viram contexto extra na issue
 */
const buildErrorFromArgs = (args) => {
	const errArg = args.find((a) => a instanceof Error);
	if (errArg) {
		return { err: errArg, extra: args.filter((a) => a !== errArg) };
	}
	const [first, ...rest] = args;
	const msg = typeof first === 'string' ? first : 'logger.error';
	return { err: new Error(msg), extra: rest };
};

export const logger = {
	debug: (...args) => {
		if (!isProduction) {
			// eslint-disable-next-line no-console
			console.log(...args);
		}
	},
	info: (...args) => {
		if (!isProduction) {
			// eslint-disable-next-line no-console
			console.info(...args);
		}
	},
	warn: (...args) => {
		// eslint-disable-next-line no-console
		console.warn(...args);
	},
	error: (...args) => {
		// eslint-disable-next-line no-console
		console.error(...args);
		const { err, extra } = buildErrorFromArgs(args);
		captureError(err, { args: extra.length ? extra : undefined });
	},
};

export default logger;
